import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { UXPContext } from '@core/context/Context';
import Chip from '@widget/other/Chip';
/** Beta's colour is fixed here, whatever variant was saved with it; other tags use their own. */
function tagVariant(tag) {
    return String(tag.label).trim().toLowerCase() === 'beta' ? 'info' : tag.variant || 'secondary';
}
/** A navigation link's tags (Beta, ...) as small chips next to its label. Nothing when it has none. */
const NavLinkTagsBase = ({ link }) => {
    var _a;
    const context = useContext(UXPContext);
    if (!((_a = link === null || link === void 0 ? void 0 : link.tags) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    return (_jsx("span", { className: "uxpcore_navlinktags", children: link.tags.map((tag) => (_jsx(Chip, { label: context.$L(tag.label), variant: tagVariant(tag), size: "small" }, tag.label))) }));
};
export const NavLinkTags = memo(NavLinkTagsBase);
